module.exports = __webpack_public_path__ + "success_check_new.d92d2fea1ae1fd7d914743a46b330220.svg";